import {BaseMyopMessage} from "../BaseMessage";

export class SetResizeObserverMessage extends BaseMyopMessage {
    cleanable = true;
    messageType = 'SetResizeObserverMessage';
}

export class ResizeObserverMessage extends BaseMyopMessage {
    messageType = 'ResizeObserverMessage';
}